import { Link, Typography } from "@mui/material";

export default function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="https://www.uv.mx/sea/">
        Sistema de Enseñanza Abierta - CAM Zona UV - Universidad Veracruzana
      </Link>{" "}
      2023
    </Typography>
  );
}
